export default __webpack_public_path__ + "321f936172fc197eec85f203bc4d3f13.png";